// src/dmcaAgents.js
// Official DMCA agent addresses from US Copyright Office records
// Source: copyright.gov/dmca-directory

export const DMCA_AGENTS = {
  // ─── SEARCH & HOSTING ────────────────────────────────
  'google': {
    label: 'Google',
    agent: 'Google LLC - Copyright Agent',
    address: '1600 Amphitheatre Parkway, Mountain View, CA 94043',
    email: 'dmca-agent@google.com',
    formUrl: 'https://support.google.com/legal/troubleshooter/1114905',
  },
  'youtube': {
    label: 'YouTube',
    agent: 'YouTube LLC - Copyright Agent',
    address: '901 Cherry Ave, San Bruno, CA 94066',
    email: 'copyright@youtube.com',
    formUrl: 'https://www.youtube.com/copyright_complaint_form',
  },
  'cloudflare': {
    label: 'Cloudflare',
    agent: 'Cloudflare, Inc. - Abuse Team',
    address: '101 Townsend St, San Francisco, CA 94107',
    email: 'abuse@cloudflare.com',
    formUrl: 'https://www.cloudflare.com/abuse/form',
  },
  'bing': {
    label: 'Bing / Microsoft',
    agent: 'Microsoft Corporation - DMCA Agent',
    address: 'One Microsoft Way, Redmond, WA 98052',
    email: 'msndmca@microsoft.com',
    formUrl: 'https://www.microsoft.com/en-us/concern/dmca',
  },
  'microsoft': {
    label: 'Microsoft',
    agent: 'Microsoft Corporation - DMCA Agent',
    address: 'One Microsoft Way, Redmond, WA 98052',
    email: 'msndmca@microsoft.com',
    formUrl: 'https://www.microsoft.com/en-us/concern/dmca',
  },
  'yahoo': {
    label: 'Yahoo',
    agent: 'Yahoo Inc. - Copyright Agent',
    address: '770 Broadway, New York, NY 10003',
    email: 'dmca@yahoo-inc.com',
    formUrl: 'https://yahoo.com/copyright',
  },

  // ─── SOCIAL MEDIA ────────────────────────────────────
  'facebook': {
    label: 'Facebook / Meta',
    agent: 'Meta Platforms, Inc. - Designated Copyright Agent',
    address: '1601 Willow Road, Menlo Park, CA 94025',
    email: 'ip@meta.com',
    formUrl: 'https://www.facebook.com/help/contact/634636770043106',
  },
  'meta': {
    label: 'Meta / Facebook',
    agent: 'Meta Platforms, Inc. - Designated Copyright Agent',
    address: '1601 Willow Road, Menlo Park, CA 94025',
    email: 'ip@meta.com',
    formUrl: 'https://www.facebook.com/help/contact/634636770043106',
  },
  'instagram': {
    label: 'Instagram',
    agent: 'Meta Platforms, Inc. - Designated Copyright Agent',
    address: '1601 Willow Road, Menlo Park, CA 94025',
    email: 'ip@meta.com',
    formUrl: 'https://help.instagram.com/contact/372592039498237',
  },
  'twitter': {
    label: 'X (Twitter)',
    agent: 'X Corp. - Copyright Agent',
    address: '1355 Market Street, Suite 900, San Francisco, CA 94103',
    email: 'copyright@twitter.com',
    formUrl: 'https://help.twitter.com/forms/dmca',
  },
  'x': {
    label: 'X (Twitter)',
    agent: 'X Corp. - Copyright Agent',
    address: '1355 Market Street, Suite 900, San Francisco, CA 94103',
    email: 'copyright@twitter.com',
    formUrl: 'https://help.twitter.com/forms/dmca',
  },
  'tiktok': {
    label: 'TikTok',
    agent: 'TikTok Inc. - Copyright Agent',
    address: '5800 Bristol Pkwy, Suite 100, Culver City, CA 90230',
    email: 'copyright@tiktok.com',
    formUrl: 'https://www.tiktok.com/legal/report/Copyright',
  },
  'pinterest': {
    label: 'Pinterest',
    agent: 'Pinterest, Inc. - Copyright Agent',
    address: '651 Brannan Street, San Francisco, CA 94107-1532',
    email: 'copyright@pinterest.com',
    formUrl: 'https://www.pinterest.com/about/copyright/dmca-pin/',
  },
  'linkedin': {
    label: 'LinkedIn',
    agent: 'LinkedIn Corporation - DMCA Agent',
    address: '1000 West Maude Avenue, Sunnyvale, CA 94085',
    email: 'copyright@linkedin.com',
    formUrl: 'https://www.linkedin.com/help/linkedin/ask/TS-NFIO',
  },
  'snapchat': {
    label: 'Snapchat',
    agent: 'Snap Inc. - Copyright Agent',
    address: '3000 31st Street, Santa Monica, CA 90405',
    email: 'copyright@snap.com',
    formUrl: 'https://support.snapchat.com/en-US/i-need-help',
  },
  'snap': {
    label: 'Snapchat',
    agent: 'Snap Inc. - Copyright Agent',
    address: '3000 31st Street, Santa Monica, CA 90405',
    email: 'copyright@snap.com',
    formUrl: 'https://support.snapchat.com/en-US/i-need-help',
  },
  'threads': {
    label: 'Threads',
    agent: 'Meta Platforms, Inc. - Designated Copyright Agent',
    address: '1601 Willow Road, Menlo Park, CA 94025',
    email: 'ip@meta.com',
    formUrl: 'https://help.instagram.com/contact/372592039498237',
  },
  'tumblr': {
    label: 'Tumblr',
    agent: 'Tumblr, Inc. - Designated Agent',
    address: '770 Broadway, New York, NY 10003',
    email: 'dmca@tumblr.com',
    formUrl: 'https://www.tumblr.com/dmca',
  },
  'twitch': {
    label: 'Twitch',
    agent: 'Twitch Interactive, Inc. - Copyright Agent',
    address: '350 Bush Street, 2nd Floor, San Francisco, CA 94104',
    email: 'dmca@twitch.tv',
    formUrl: 'https://www.twitch.tv/p/en/legal/dmca-guidelines/',
  },
  'discord': {
    label: 'Discord',
    agent: 'Discord Inc. - Copyright Agent',
    address: '444 De Haro Street, Suite 200, San Francisco, CA 94107',
    email: 'copyright@discord.com',
    formUrl: 'https://discord.com/dmca',
  },
  'telegram': {
    label: 'Telegram',
    agent: 'Telegram Messenger Inc. - Copyright Agent',
    address: '1209 Orange Street, Wilmington, DE 19801',
    email: 'dmca@telegram.org',
    formUrl: 'https://telegram.org/dmca',
  },

  // ─── STORAGE & HOSTING ───────────────────────────────
  'amazon': {
    label: 'Amazon / AWS',
    agent: 'Amazon.com, Inc. - Copyright Agent',
    address: '2021 7th Avenue, Seattle, WA 98121',
    email: 'copyright@amazon.com',
    formUrl: 'https://www.amazon.com/report/infringement',
  },
  'aws': {
    label: 'Amazon Web Services',
    agent: 'Amazon.com, Inc. - Copyright Agent',
    address: '2021 7th Avenue, Seattle, WA 98121',
    email: 'copyright@amazon.com',
    formUrl: 'https://www.amazon.com/report/infringement',
  },
  'wordpress': {
    label: 'WordPress / Automattic',
    agent: 'Automattic Inc. - Designated Agent',
    address: '60 29th Street #343, San Francisco, CA 94110',
    email: 'dmca@automattic.com',
    formUrl: 'https://automattic.com/dmca/',
  },
  'automattic': {
    label: 'Automattic / WordPress',
    agent: 'Automattic Inc. - Designated Agent',
    address: '60 29th Street #343, San Francisco, CA 94110',
    email: 'dmca@automattic.com',
    formUrl: 'https://automattic.com/dmca/',
  },
  'reddit': {
    label: 'Reddit',
    agent: 'Reddit, Inc. - Copyright Agent',
    address: '303 2nd Street, Suite 500S, San Francisco, CA 94107',
    email: 'copyright@reddit.com',
    formUrl: 'https://www.reddit.com/r/dmca',
  },
  'github': {
    label: 'GitHub',
    agent: 'GitHub, Inc. - DMCA Agent',
    address: '88 Colin P. Kelly Jr. Street, San Francisco, CA 94107',
    email: 'copyright@github.com',
    formUrl: 'https://support.github.com/contact/dmca',
  },
  'dropbox': {
    label: 'Dropbox',
    agent: 'Dropbox, Inc. - Copyright Agent',
    address: '1800 Owens Street, San Francisco, CA 94158',
    email: 'dmca@dropbox.com',
    formUrl: 'https://www.dropbox.com/dmca',
  },
  'wix': {
    label: 'Wix',
    agent: 'Wix.com Ltd. - Copyright Agent',
    address: '40 Namal Tel Aviv Street, Tel Aviv 6350671, Israel',
    email: 'abuse@wix.com',
    formUrl: 'https://support.wix.com/en/article/reporting-copyright-infringement-dmca',
  },
  'squarespace': {
    label: 'Squarespace',
    agent: 'Squarespace, Inc. - Copyright Agent',
    address: '225 Varick Street, 12th Floor, New York, NY 10014',
    email: 'dmca@squarespace.com',
    formUrl: 'https://support.squarespace.com/hc/en-us/articles/205815928',
  },
  'shopify': {
    label: 'Shopify',
    agent: 'Shopify Inc. - Copyright Agent',
    address: '151 O\'Connor Street, Ground Floor, Ottawa, Ontario K2P 2L8, Canada',
    email: 'legal@shopify.com',
    formUrl: 'https://www.shopify.com/dmca',
  },
  'godaddy': {
    label: 'GoDaddy',
    agent: 'GoDaddy.com, LLC - Copyright Agent',
    address: '14455 N. Hayden Road, Scottsdale, AZ 85260',
    email: 'abuse@godaddy.com',
    formUrl: 'https://www.godaddy.com/legal/agreements/dmca-policy',
  },
  'hostgator': {
    label: 'HostGator',
    agent: 'HostGator - Abuse Department',
    address: '5005 Mitchelldale St, Suite #100, Houston, TX 77092',
    email: 'dmca@hostgator.com',
    formUrl: 'https://www.hostgator.com/dmca',
  },
  'bluehost': {
    label: 'Bluehost',
    agent: 'Bluehost Inc. - Copyright Agent',
    address: '1958 South 950 East, Provo, UT 84606',
    email: 'dmca@bluehost.com',
    formUrl: 'https://www.bluehost.com/dmca',
  },
  'namecheap': {
    label: 'Namecheap',
    agent: 'Namecheap, Inc. - Abuse Department',
    address: '4600 East Washington Street, Suite 305, Phoenix, AZ 85034',
    email: 'abuse@namecheap.com',
    formUrl: 'https://www.namecheap.com/legal/general/dmca-policy/',
  },

  // ─── MARKETPLACES ────────────────────────────────────
  'etsy': {
    label: 'Etsy',
    agent: 'Etsy, Inc. - Copyright Agent',
    address: '117 Adams Street, Brooklyn, NY 11201',
    email: 'dmca@etsy.com',
    formUrl: 'https://www.etsy.com/legal/ip/',
  },
  'ebay': {
    label: 'eBay',
    agent: 'eBay Inc. - Copyright Agent',
    address: '2025 Hamilton Avenue, San Jose, CA 95125',
    email: 'copyright@ebay.com',
    formUrl: 'https://www.ebay.com/help/policies/member-behaviour-policies/verified-rights-owner-vero-programme',
  },
  'aliexpress': {
    label: 'AliExpress / Alibaba',
    agent: 'Alibaba.com - IPP Team',
    address: '400 S El Camino Real, Suite 400, San Mateo, CA 94402',
    email: 'ipp@service.alibaba.com',
    formUrl: 'https://rule.alibaba.com/rule/detail/2034.htm',
  },
  'redbubble': {
    label: 'Redbubble',
    agent: 'Redbubble Inc. - Copyright Agent',
    address: '111 Sutter Street, Suite 400, San Francisco, CA 94104',
    email: 'copyright@redbubble.com',
    formUrl: 'https://www.redbubble.com/dmca',
  },
  'teepublic': {
    label: 'TeePublic',
    agent: 'TeePublic - Copyright Agent',
    address: '767 3rd Avenue, New York, NY 10017',
    email: 'dmca@teepublic.com',
    formUrl: 'https://www.teepublic.com/dmca',
  },

  // ─── MEDIA & STREAMING ───────────────────────────────
  'vimeo': {
    label: 'Vimeo',
    agent: 'Vimeo, LLC - Copyright Agent',
    address: '555 West 18th Street, New York, NY 10011',
    email: 'dmca@vimeo.com',
    formUrl: 'https://vimeo.com/dmca',
  },
  'spotify': {
    label: 'Spotify',
    agent: 'Spotify AB - Copyright Agent',
    address: '4 World Trade Center, 150 Greenwich Street, New York, NY 10007',
    email: 'copyright@spotify.com',
    formUrl: 'https://www.spotify.com/legal/copyright-policy/',
  },
  'soundcloud': {
    label: 'SoundCloud',
    agent: 'SoundCloud Limited - Copyright Agent',
    address: 'Invalidenstraße 112, 10115 Berlin, Germany',
    email: 'copyright@soundcloud.com',
    formUrl: 'https://soundcloud.com/pages/copyright',
  },
  'apple': {
    label: 'Apple / iTunes',
    agent: 'Apple Inc. - Copyright Agent',
    address: 'One Apple Park Way, Cupertino, CA 95014',
    email: 'copyrightinfringement@apple.com',
    formUrl: 'https://www.apple.com/legal/internet-services/itunes/us/terms.html',
  },
  'netflix': {
    label: 'Netflix',
    agent: 'Netflix, Inc. - Copyright Agent',
    address: '100 Winchester Circle, Los Gatos, CA 95032',
    email: 'dmca@netflix.com',
    formUrl: 'https://help.netflix.com/legal/corpinfo',
  },
  'dailymotion': {
    label: 'Dailymotion',
    agent: 'Dailymotion SA - Copyright Agent',
    address: '50 rue Camille Desmoulins, 92130 Issy-les-Moulineaux, France',
    email: 'dmca@dailymotion.com',
    formUrl: 'https://www.dailymotion.com/legal/copyright',
  },

  // ─── AI & TECH ───────────────────────────────────────
  'openai': {
    label: 'OpenAI',
    agent: 'OpenAI, L.L.C. - Copyright Agent',
    address: '3180 18th Street, San Francisco, CA 94110',
    email: 'copyright@openai.com',
    formUrl: 'https://openai.com/policies/terms-of-use',
  },
  'midjourney': {
    label: 'Midjourney',
    agent: 'Midjourney, Inc. - Copyright Agent',
    address: '101 2nd Street, Suite 100, San Francisco, CA 94105',
    email: 'dmca@midjourney.com',
    formUrl: 'https://docs.midjourney.com/docs/terms-of-service',
  },

  // ─── ADULT CONTENT PLATFORMS ─────────────────────────
  'onlyfans': {
    label: 'OnlyFans',
    agent: 'Fenix Internet LLC - Copyright Agent',
    address: '9255 Sunset Blvd #1100, West Hollywood, CA 90069',
    email: 'dmca@onlyfans.com',
    formUrl: 'https://onlyfans.com/dmca',
  },

  // ─── FILE SHARING ─────────────────────────────────────
  'scribd': {
    label: 'Scribd',
    agent: 'Scribd, Inc. - Copyright Agent',
    address: '460 Bryant Street, Suite 100, San Francisco, CA 94107',
    email: 'copyright@scribd.com',
    formUrl: 'https://support.scribd.com/hc/en-us/articles/210129146',
  },
  'issuu': {
    label: 'Issuu',
    agent: 'Issuu, Inc. - Copyright Agent',
    address: '131 Steuart Street, Suite 400, San Francisco, CA 94105',
    email: 'copyright@issuu.com',
    formUrl: 'https://issuu.com/legal/terms',
  },
  'slideshare': {
    label: 'SlideShare / LinkedIn',
    agent: 'LinkedIn Corporation - DMCA Agent',
    address: '1000 West Maude Avenue, Sunnyvale, CA 94085',
    email: 'copyright@linkedin.com',
    formUrl: 'https://www.slideshare.net/dmca',
  },
};

// ─── Typo / alias map ────────────────────────
// Maps common misspellings and aliases to canonical keys
const ALIASES = {
  'pintrest':   'pinterest',
  'pinterst':   'pinterest',
  'pinteres':   'pinterest',
  'utubbe':     'youtube',
  'youtub':     'youtube',
  'u tube':     'youtube',
  'utube':      'youtube',
  'facebok':    'facebook',
  'faceboook':  'facebook',
  'fb':         'facebook',
  'insta':      'instagram',
  'ig':         'instagram',
  'instgram':   'instagram',
  'twiter':     'twitter',
  'twt':        'twitter',
  'twtter':     'twitter',
  'tok':        'tiktok',
  'tik tok':    'tiktok',
  'tic toc':    'tiktok',
  'tiktok':     'tiktok',
  'amazn':      'amazon',
  'amzon':      'amazon',
  'amazone':    'amazon',
  'wordpres':   'wordpress',
  'wordpreess': 'wordpress',
  'wp':         'wordpress',
  'guthub':     'github',
  'git hub':    'github',
  'gitub':      'github',
  'spotfy':     'spotify',
  'spotifi':    'spotify',
  'reditt':     'reddit',
  'redit':      'reddit',
  'linkdin':    'linkedin',
  'linkedn':    'linkedin',
  'snpachat':   'snapchat',
  'snapcht':    'snapchat',
  'cloudflair': 'cloudflare',
  'cloudfare':  'cloudflare',
  'ebya':       'ebay',
  'etsey':      'etsy',
  'etzy':       'etsy',
  'vemeo':      'vimeo',
  'viemo':      'vimeo',
  'discrod':    'discord',
  'disocrd':    'discord',
  'twich':      'twitch',
  'twtich':     'twitch',
  'shopfiy':    'shopify',
  'shopfiy':    'shopify',
  'sqaurespace':'squarespace',
  'sqspace':    'squarespace',
  'wxi':        'wix',
};

// ─── Match user input to a known platform ────
export const findAgent = (platformInput) => {
  if (!platformInput) return null;

  // Normalize: lowercase, strip non-alpha chars
  const raw = platformInput.toLowerCase().trim();
  const key = raw.replace(/[^a-z]/g, '');

  // 1. Direct key match
  if (DMCA_AGENTS[key]) return DMCA_AGENTS[key];

  // 2. Alias / typo match (normalized)
  const aliasNorm = raw.replace(/[^a-z]/g, '');
  if (ALIASES[aliasNorm]) return DMCA_AGENTS[ALIASES[aliasNorm]];

  // 3. Alias match on raw (with spaces preserved, e.g. "tik tok")
  if (ALIASES[raw]) return DMCA_AGENTS[ALIASES[raw]];

  // 4. Partial match — key contains or is contained by a known agent key
  const found = Object.keys(DMCA_AGENTS).find(k =>
    key.includes(k) || k.includes(key)
  );
  if (found) return DMCA_AGENTS[found];

  // 5. Fuzzy match — check if input starts with any known key (min 4 chars)
  const fuzzy = Object.keys(DMCA_AGENTS).find(k =>
    k.length >= 4 && (key.startsWith(k.slice(0, 4)) || k.startsWith(key.slice(0, 4)))
  );
  if (fuzzy) return DMCA_AGENTS[fuzzy];

  return null;
};

export default DMCA_AGENTS;